<div class="m-timeslot">
  <div class="m-timeslot__field">
    <label class="m-timeslot__label">{{ 'NEXPE.CUTOFF.START_HOUR' | translate }}</label>
    <input
      type="number"
      class="m-timeslot__input"
      [value]="timeSlot().startCutOffHour"
      (input)="onFieldChange('startCutOffHour', $any($event.target).value)"
      min="0"
      max="23"
    />
  </div>

  <div class="m-timeslot__field">
    <label class="m-timeslot__label">{{ 'NEXPE.CUTOFF.FIXED_HOUR' | translate }}</label>
    <input
      type="number"
      class="m-timeslot__input"
      [value]="timeSlot().fixedCutOffHour"
      (input)="onFieldChange('fixedCutOffHour', $any($event.target).value)"
      min="0"
      max="23"
    />
  </div>

  <div class="m-timeslot__field">
    <label class="m-timeslot__label">{{ 'NEXPE.CUTOFF.DELAYED_DAYS' | translate }}</label>
    <input
      type="number"
      class="m-timeslot__input"
      [value]="timeSlot().fixedCutOffDelayedDays"
      (input)="onFieldChange('fixedCutOffDelayedDays', $any($event.target).value)"
      min="0"
    />
  </div>

  <div class="m-timeslot__field">
    <label class="m-timeslot__label">{{ 'NEXPE.CUTOFF.DELAYED_HOURS' | translate }}</label>
    <input
      type="number"
      class="m-timeslot__input"
      [value]="timeSlot().delayedCutOffHours ?? ''"
      (input)="onFieldChange('delayedCutOffHours', $any($event.target).value)"
      min="0"
      placeholder="Optional"
    />
  </div>

  <button type="button" class="m-timeslot__delete" (click)="onDelete()">
    {{ 'COMMON.DELETE' | translate }}
  </button>
</div>
